<template>
  <div class="lbv-leak-list animated fadeIn roundedCard">
    <div class="row">
      <div class="col-lg-12">
        <b-card>
          <div class="col-lg-12 leak-list-header">
            <span class="lbv-page-title">Leak List</span>
          </div>
          <div class="row secondary lbv-search">
            <form
              class="lbv-search-filter leak-list-form"
              @submit.prevent="search"
            >
              <div class="leaklistFilters w-100">
                <b-row>
                  <b-col cols="6">
                    <b-form-group
                      label="Device ID"
                      label-for="device-id"
                    >
                      <input
                        id="device-id"
                        v-model="searchDeviceID"
                        type="text"
                        class="form-control full-width"
                        placeholder="LeakBot ID"
                      >
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group
                      label="Tenant"
                      label-for="tenant-id"
                    >
                      <b-form-select
                        id="tenant-id"
                        v-model="tenantSelection"
                        class="full-width"
                      >
                        <option :value="null">
                          All Tenants
                        </option>
                        <option
                          v-for="tenant in tenants"
                          v-bind="$attrs"
                          :key="tenant.id"
                          :value="{ id: tenant.id }"
                          @option="$emit('option', $event.target.value)"
                        >
                          {{ tenant.name }}
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group
                      label="Need Help"
                      label-for="need-help"
                    >
                      <b-form-select
                        id="need-help"
                        v-model="typeSelection"
                        class="full-width"
                      >
                        <option :value="null">
                          All
                        </option>
                        <option value="AllFixed">
                          All Fixed
                        </option>
                        <option value="CustomerRepaired">
                          Customer Repaired
                        </option>
                        <option value="DrippingTap">
                          Dripping Tap
                        </option>
                        <option value="FixMyself">
                          Fix Myself
                        </option>
                        <option value="GetHelp">
                          Get Help
                        </option>
                        <option value="KnowWhatItIs">
                          Know What It Is
                        </option>
                        <option value="LeakingToilet">
                          Leaking Toilet
                        </option>
                        <option value="NoneOfThese">
                          None Of These
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="3">
                    <b-form-group
                      label="Date from"
                      label-for="date-from"
                    >
                      <b-form-input
                        id="date-from"
                        v-model="dateFrom"
                        type="date"
                        class="date-picker w-100"
                        name="dateFrom"
                        placeholder="YYYY-MM-DD"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group
                      label="Date to"
                      label-for="date-to"
                    >
                      <input
                        id="date-to"
                        v-model="dateTo"
                        type="date"
                        class="form-control date-picker w-100"
                        name="dateTo"
                        placeholder="YYYY-MM-DD"
                      >
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group
                      label="Status"
                      label-for="status-filter"
                    >
                      <b-form-select
                        id="status-filter"
                        v-model="statusSelection"
                        class="full-width"
                      >
                        <option :value="null">
                          All
                        </option>
                        <option value="open">
                          open
                        </option>
                        <option value="closed">
                          closed
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col
                    cols="3"
                    class="d-flex align-items-center"
                  >
                    <b-button
                      id="applyBtn"
                      type="submit"
                      variant="primary"
                      class="w-100 mr-3"
                      :disabled="applyBtnDisabled"
                    >
                      Apply
                    </b-button>
                    <b-button
                      type="submit"
                      variant="primary"
                      class="w-100"
                      @click.prevent="downloadReport"
                    >
                      <span class="download">Export CSV File</span>
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </form>
          </div>
          <b-alert
            :show="errorMessage != ''"
            variant="danger"
          >
            {{ errorMessage }}
          </b-alert>
          <b-table
            small
            responsive
            striped
            hover
            :items="deviceList"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
          >
            <template
              slot="leakbotId"
              slot-scope="data"
            >
              <!--<router-link :to="`deviceview/${data.value}`" class="deviceLink">{{data.value}}</router-link>-->
              <router-link
                :to="{ name: 'DeviceView', params: { deviceID: data.value }}"
                class="deviceLink"
              >
                {{ data.value }}
              </router-link>
            </template>
            <template
              slot="needHelp"
              slot-scope="data"
            >
              <strong v-if="data.item.needHelp === 'GetHelp'">{{ data.value }}</strong>
              <div v-else>
                {{ data.value }}
              </div>
            </template>
            <template
              slot="repairComplete"
              slot-scope="data"
            >
              <strong v-if="data.item.repairComplete === 'GetHelp'">{{ data.value }}</strong>
              <div v-else>
                {{ data.value }}
              </div>
            </template>
          </b-table>
          <b-button
            class="page prev"
            variant="primary"
            size="sm"
            :disabled="pageNumber === 1"
            @click.prevent="page"
          >
            Prev
          </b-button>

          <b-button
            class="page next"
            variant="primary"
            size="sm"
            :disabled="!hasNextPage"
            @click.prevent="page"
          >
            Next
          </b-button>
          <div class="current-page">
            Page: {{ pageNumber }}
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import leakListMixin from '../mixins/leakListMixin'

export default {
  name: 'LeakList',
  mixins: [leakListMixin]
}
</script>
<style media="screen">
  .lbv-leak-list .leaklistFilters .full-width {
    width: 100% !important;
  }

  .lbv-leak-list .leaklistFilters label {
    font-size: 0.8rem
  }

  .lbv-leak-list .leaklistFilters .push-down {
    margin-top: 1rem;
  }

</style>
